import React from 'react'
import { Navigate, Outlet, useLocation } from 'react-router'
import { useAppSelector } from '../../../redux/store'
import {
  selectAuthLoading,
  selectIsAuthenticated,
  selectUserRole,
  selectUser,
} from '../../../redux/auth/selector'

import { UserRole } from '../../../redux/auth/types'
import FullPageLoader from '../Loading/FullPageLoader'

interface ProtectedRouteProps {
  allowedRoles?: UserRole[]
}

const ProtectedRoute: React.FC<ProtectedRouteProps> = ({ allowedRoles }) => {
  const location = useLocation()

  // Use selectors from Redux store
  const isAuthenticated = useAppSelector(selectIsAuthenticated)
  const userRole = useAppSelector(selectUserRole)
  const user = useAppSelector(selectUser)
  const loading = useAppSelector(selectAuthLoading)

  // Show loading spinner if the authentication status is being checked
  if (loading) {
    return <FullPageLoader message='Checking authentication...' />
  }

  // Redirect to login if the user is not authenticated or user object is empty
  if (!isAuthenticated || Object.keys(user).length === 0) {
    sessionStorage.setItem('redirectPath', location.pathname)
    return <Navigate to='/login' />
  }

  // Redirect to unauthorized page if the user is authenticated but not allowed
  if (allowedRoles && !allowedRoles.includes(userRole as UserRole)) {
    return <Navigate to='/unauthorized' />
  }

  // Render the protected route if the user is authenticated and authorized
  return <Outlet />
}

export default ProtectedRoute
